import { Reveal } from "@/components/Reveal";

const NEEDS = [
  { label: "Speech delays", color: "#F7C948" },
  { label: "Articulation difficulties", color: "#8FB8E8" },
  { label: "Language disorders", color: "#9CCB9C" },
  { label: "Fluency (stammering)", color: "#F2A9C4" },
  { label: "Autism spectrum support", color: "#F7C948" },
  { label: "Learning support needs", color: "#8FB8E8" },
  { label: "Hearing impairment", color: "#9CCB9C" },
  { label: "Social communication", color: "#F2A9C4" },
];

export const WhoWeHelp = () => (
  <section id="who-we-help" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
    <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <p className="mb-4 font-mono text-xs font-medium uppercase tracking-[0.28em] text-pine-700">Who we help</p>
        <h2 className="font-serif text-2xl font-semibold tracking-tight text-pine-950 sm:text-3xl lg:text-4xl">
          The students who slip through the cracks — until someone listens.
        </h2>
        <p className="mt-5 text-sm leading-relaxed text-stone-600 sm:text-base">
          One in ten children has a speech, language, or communication need.
          Most are bright, capable students who simply haven't found their way
          in yet.
        </p>
      </Reveal>

      <div className="lg:col-span-8">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {NEEDS.map((n, i) => (
            <Reveal key={n.label} delay={(i % 2) * 0.07}>
              <div
                data-testid={`need-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="flex h-full items-center gap-4 rounded-2xl border border-pine-900/10 bg-white px-6 py-5 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-honey hover:shadow-lg"
              >
                <span className="h-3 w-3 shrink-0 rounded-full" style={{ backgroundColor: n.color }} />
                <span className="font-serif text-lg font-semibold text-pine-950">{n.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
